"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/upload/style");
var _upload = _interopRequireDefault(require("antd/lib/upload"));
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
var _UploaderViewModes = require("./UploaderViewModes");
require("../PatientInfo/PatientInfo.less");
require("./ImageUploader.less");
var _uploadIcon = _interopRequireDefault(require("../../images/uploadIcon.svg"));
var _lodash = require("lodash");
var _detectFileType = _interopRequireDefault(require("detect-file-type"));
var _RemoveIcon = _interopRequireDefault(require("./RemoveIcon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var Text = _typography.default.Text;
function validate(file, typeDerivedFromImage, validators) {
  return (validators || []).reduce(function (result, validate) {
    var _validate = validate(file, typeDerivedFromImage),
      isValid = _validate.isValid,
      message = _validate.message;
    if (!isValid) {
      _utils.toast.error({
        title: message
      });
    }
    return result && isValid;
  }, true);
}
function getLabelledUploader(_ref) {
  var imagePlaceholder = _ref.placeholder,
    label = _ref.label,
    accept = _ref.accept;
  var isCsv = accept.includes('csv');
  return /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-between",
    align: "top"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "image-uploader flex flex-col md:flex-row"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    md: 12,
    lg: 10
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "labelled-image-placeholder position-relative"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ant-upload-preview"
  }, imagePlaceholder), !isCsv && /*#__PURE__*/_react.default.createElement(Text, {
    className: "ant-upload-label"
  }, "Change photo"))), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    md: 12,
    lg: 14,
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement(Text, {
    className: "ant-upload-text"
  }, label)))));
}
function getBase64(file) {
  return new Promise(function (resolve, reject) {
    var _file$type;
    if ((_file$type = file.type) !== null && _file$type !== void 0 && _file$type.startsWith('image')) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        return resolve(reader.result);
      };
      reader.onerror = function (error) {
        return reject(error);
      };
    } else {
      resolve(undefined);
    }
  });
}
var decodeImage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file, onDecodeImage) {
    var url, img;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = URL.createObjectURL(file.originFileObj);
            img = new Image();
            img.src = url;
            _context.next = 5;
            return img.decode();
          case 5:
            onDecodeImage(img);
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function decodeImage(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
var ImageUploader = function ImageUploader(props, ref) {
  var _props$data__field;
  var imageId = props.imageId,
    _props$uploading = props.uploading,
    uploading = _props$uploading === void 0 ? false : _props$uploading,
    placeholderText = props.placeholderText,
    _props$label = props.label,
    label = _props$label === void 0 ? 'Use a portrait photo against plain background. Requirements: file format - .bmp, .gif, .jpeg, .png, maximum file size - 20Mb' : _props$label,
    _props$nonImagePlaceh = props.nonImagePlaceholderText,
    nonImagePlaceholderText = _props$nonImagePlaceh === void 0 ? 'View ID Card' : _props$nonImagePlaceh,
    disabled = props.disabled,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? _utils.noop : _props$onChange,
    onDecodeImage = props.onDecodeImage,
    validators = props.validators,
    _props$accept = props.accept,
    accept = _props$accept === void 0 ? _utils.ACCEPT_IMAGE_TYPES.join(',') : _props$accept,
    _props$showUploadList = props.showUploadList,
    showUploadList = _props$showUploadList === void 0 ? {
      showPreviewIcon: false,
      showRemoveIcon: false
    } : _props$showUploadList,
    _props$viewMode = props.viewMode,
    viewMode = _props$viewMode === void 0 ? _UploaderViewModes.UploaderViewModes.PICTURE_CARD : _props$viewMode,
    form = props.form,
    _props$previewImageSr = props.previewImageSrc,
    previewImageSrc = _props$previewImageSr === void 0 ? (0, _utils.getAccountImageUrl)(imageId) : _props$previewImageSr,
    _props$previewClassNa = props.previewClassName,
    previewClassName = _props$previewClassNa === void 0 ? 'mb-[24px]' : _props$previewClassNa,
    _props$removeIcon = props.removeIcon,
    removeIcon = _props$removeIcon === void 0 ? {
      className: ''
    } : _props$removeIcon;
  var formFieldId = (_props$data__field = props['data-__field']) === null || _props$data__field === void 0 ? void 0 : _props$data__field.name;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    fileList = _useState2[0],
    setFileList = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isImage = _useState4[0],
    setIsImage = _useState4[1];
  // Used to ensure the error alert doesn’t appear on initial page load.
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    didRemoveImage = _useState6[0],
    setDidRemoveImage = _useState6[1];
  var isLabelledCardViewMode = viewMode === _UploaderViewModes.UploaderViewModes.LABELLED_CARD;
  (0, _react.useEffect)(function () {
    if (imageId && !uploading) {
      setFileList([]);
      onChange([{
        originFileObj: null
      }]);
    }
  }, [imageId, isImage]);
  var beforeUpload = function beforeUpload() {
    return false;
  };
  var handleUploadChange = function handleUploadChange(info) {
    var file = info.file,
      fileList = info.fileList;
    var fileFromList = fileList.slice(-1);
    if (fileFromList[0]) {
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);

      // We derive the actual image file type from file data, in case the file was corrupted by changing
      // the actual file extension to another one. Antd Uploader is not doing that right, in such case
      reader.onload = function (e) {
        return _detectFileType.default.fromBuffer(e.target.result, function (error, typeDerivedFromFile) {
          // Generic pre-validation message
          if (error) {
            _utils.toast.error({
              title: 'An error occurred while processing the file preview. Please review the file choice and try again'
            });
            return;
          }
          var attachedFiles = validate(file, typeDerivedFromFile || undefined, validators) ? fileFromList : [];
          setFileList(attachedFiles);

          // If there is a preloaded image
          if (imageId && isImage && (0, _lodash.isEmpty)(attachedFiles)) {
            onChange([{
              originFileObj: null
            }]);
          } else {
            onChange(attachedFiles);
          }
          if (onDecodeImage && (0, _lodash.includes)(_utils.ACCEPT_IMAGE_TYPES, typeDerivedFromFile === null || typeDerivedFromFile === void 0 ? void 0 : typeDerivedFromFile.mime)) {
            decodeImage(attachedFiles[0], onDecodeImage);
          }
        });
      };
    } else {
      // This case handles deleting the previewed image
      setFileList([]);
      onChange([]);
    }
  };
  var image = isLabelledCardViewMode ? /*#__PURE__*/_react.default.createElement("div", {
    className: "upload-preview-container",
    style: {
      backgroundImage: "url(".concat(previewImageSrc, ")")
    }
  }) : isImage ? /*#__PURE__*/_react.default.createElement("img", {
    src: previewImageSrc,
    alt: "id",
    className: (0, _classnames.default)('w-full', previewClassName),
    onError: function onError() {
      setIsImage(false);
    }
  }) : /*#__PURE__*/_react.default.createElement("a", {
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    className: "block",
    href: "".concat(previewImageSrc, "?content=pdf"),
    target: "_blank",
    rel: "noopener noreferrer"
  }, nonImagePlaceholderText);
  var placeholder = /*#__PURE__*/_react.default.createElement("div", null, imageId ? image : /*#__PURE__*/_react.default.createElement("img", {
    src: _uploadIcon.default,
    alt: "Upload file",
    className: "mb-[24px]"
  }), placeholderText);
  var isFileLoaded = !(0, _lodash.isEmpty)(fileList);
  var isPreview = !!imageId;
  var isFileShown = isFileLoaded || isPreview;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_upload.default, {
    ref: ref,
    className: (0, _classnames.default)(isLabelledCardViewMode && 'with-label', !isFileShown && 'min-h-[173px]', isPreview && !isFileLoaded && 'with-preview'),
    disabled: disabled || uploading,
    accept: accept,
    multiple: false,
    fileList: fileList,
    listType: "picture-card",
    showUploadList: showUploadList,
    beforeUpload: beforeUpload,
    onChange: handleUploadChange,
    onRemove: function onRemove() {
      return setDidRemoveImage(true);
    },
    previewFile: getBase64
  }, uploading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute w-full h-full bg-white opacity-50"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute w-full h-full flex justify-center items-center"
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    size: "large",
    spinning: true
  }))), /*#__PURE__*/_react.default.createElement(_RemoveIcon.default, {
    className: removeIcon.className,
    visible: isFileLoaded,
    onClick: function onClick(e) {
      e.stopPropagation();
      setFileList([]);
      onChange([]);
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('ant-upload-preview-placeholder', {
      hidden: isFileLoaded
    })
  }, isLabelledCardViewMode ? getLabelledUploader({
    placeholder: placeholder,
    label: label,
    accept: accept
  }) : placeholder)), didRemoveImage && form && form.getFieldError(formFieldId) && /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-caption-regular text-alertred-60"
  }, form.getFieldError(formFieldId)[0]));
};
var _default = /*#__PURE__*/(0, _react.forwardRef)(ImageUploader);
exports.default = _default;
ImageUploader.propTypes = {
  imageId: _propTypes.default.string,
  uploadRequestUrl: _propTypes.default.string.isRequired,
  changeImageLabel: _propTypes.default.string,
  customRequest: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  validators: _propTypes.default.arrayOf(_propTypes.default.func),
  accept: _propTypes.default.string,
  placeholderText: _propTypes.default.string,
  label: _propTypes.default.string,
  icon: _propTypes.default.string,
  showUploadList: _propTypes.default.bool
};